import React, { useEffect, useState, useContext } from "react";
import { LanguageContext } from "App";
const Index = ({ style, setFrom, setTo, placeholder, className, reset, future }) => {
  const { translations } = useContext(LanguageContext);
  const [quickDate, setQuickDate] = useState("All Time");
  const handleChange = (e) => {
    let today = null;
    let firstDay = null;
    let lastDay = null;
    switch (e.target.value) {
      case "Today":
        setFrom(new Date().toISOString().split("T")[0]);
        setTo(new Date().toISOString().split("T")[0]);
        break;
      case "Tomorrow":
        let tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        setFrom(tomorrow.toISOString().split("T")[0]);
        setTo(tomorrow.toISOString().split("T")[0]);
        break;
      case "Yesterday":
        let yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        setFrom(yesterday.toISOString().split("T")[0]);
        setTo(yesterday.toISOString().split("T")[0]);
        break;
      case "This Week":
        today = new Date();
        firstDay = new Date(today.setDate(today.getDate() - today.getDay()));
        lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));
        setFrom(firstDay.toISOString().split("T")[0]);
        setTo(lastDay.toISOString().split("T")[0]);
        break;
      case "Next Week":
        today = new Date();
        firstDay = new Date(today.setDate(today.getDate() - today.getDay() + 7));
        lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 13));
        setFrom(firstDay.toISOString().split("T")[0]);
        setTo(lastDay.toISOString().split("T")[0]);
        break;
      case "Last Week":
        today = new Date();
        firstDay = new Date(today.setDate(today.getDate() - today.getDay() - 7));
        lastDay = new Date(today.setDate(today.getDate() - today.getDay() + 6));
        setFrom(firstDay.toISOString().split("T")[0]);
        setTo(lastDay.toISOString().split("T")[0]);
        break;
      case "This Month":
        today = new Date();
        firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
        lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        setFrom(firstDay.toISOString().split("T")[0]);
        setTo(lastDay.toISOString().split("T")[0]);
        break;
      case "Next Month":
        today = new Date();
        firstDay = new Date(today.getFullYear(), today.getMonth() + 1, 1);
        lastDay = new Date(today.getFullYear(), today.getMonth() + 2, 0);
        setFrom(firstDay.toISOString().split("T")[0]);
        setTo(lastDay.toISOString().split("T")[0]);
        break;
      case "Last Month":
        today = new Date();
        firstDay = new Date(today.getFullYear(), today.getMonth() - 1, 1);
        lastDay = new Date(today.getFullYear(), today.getMonth(), 0);
        setFrom(firstDay.toISOString().split("T")[0]);
        setTo(lastDay.toISOString().split("T")[0]);
        break;
      case "This Year":
        today = new Date();
        firstDay = new Date(today.getFullYear(), 0, 1);
        lastDay = new Date(today.getFullYear(), 11, 31);
        setFrom(firstDay.toISOString().split("T")[0]);
        setTo(lastDay.toISOString().split("T")[0]);
        break;
      case "All Time":
        setFrom("");
        setTo("");
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    setQuickDate("All Time");
  }, [reset]);

  return (
    <select
      value={quickDate}
      className={`search_input ${className}`}
      onChange={(e) => {
        setQuickDate(e.target.value);
        handleChange(e);
      }}
      style={style}
    >
      {/* <option value="">{placeholder}</option> */}
      <option value="All Time">{translations.qdAllTime}</option>
      {future ? (
        <>
          <option value="Today">{translations.qdToday}</option>
          <option value="Tomorrow">{translations.qdTomorrow}</option>
          <option value="This Week">{translations.qdThisWeek}</option>
          <option value="Next Week">{translations.qdNextWeek}</option>
          <option value="This Month">{translations.qdThisMonth}</option>
          <option value="Next Month">{translations.qdNextMonth}</option>
          <option value="This Year">{translations.qdThisYear}</option>
        </>
      ) : (
        <>
          <option value="Today">{translations.qdToday}</option>
          <option value="Yesterday">{translations.qdTomorrow}</option>
          <option value="This Week">{translations.qdThisWeek}</option>
          <option value="Last Week">{translations.qdLastWeek}</option>
          <option value="This Month">{translations.qdThisMonth}</option>
          <option value="Last Month">{translations.qdLastMonth}</option>
          <option value="This Year">{translations.qdThisYear}</option>
        </>
      )}
    </select>
  );
};

export default Index;
